import React, {Suspense, useState} from 'react';
import {useQueryLoader} from "react-relay";
import ProviderInformationDisplay, {ProviderInformationDisplayQuery} from "./ProviderInformationDisplay";
import {Button, Card, FormControl, InputGroup} from "react-bootstrap";
import DetailsPageHeader from "../../../components/common/headers/DetailsPageHeader";

const ResearchProviders = () => {
    const [tin, setTin] = useState('')
    const [providerQueryRef, loadProviderQuery] = useQueryLoader(ProviderInformationDisplayQuery);
    
    const onSearch = () => {
        loadProviderQuery({tin: tin}, {fetchPolicy: "store-or-network"})
    }
    return (
        <div>
            <DetailsPageHeader title={"Research by TIN"} iconText={"Research"} iconType={"search"}/>
            <search>
                <InputGroup className={"mb-3"}>
                    <FormControl aria-describedby={"search"} 
                                 aria-label={"search by TIN"} 
                                 id={"tinSearch"} 
                                 onChange={(e) => setTin(e.target.value)}
                                 onKeyDown={(e) => {
                                     if(e.key === "Enter") onSearch();
                                 }}
                    />
                    <Button id={"search"}
                            onClick={onSearch}
                    >
                        Search
                    </Button>
                </InputGroup>
            </search>
            {providerQueryRef != null && <Suspense fallback={"Loading"}> 
                <ProviderInformationDisplay providerQueryRef={providerQueryRef} />
            </Suspense>}
        </div>
    )
}
export default ResearchProviders